import CardSkeleton from "./CardSkeleton";
import CarouselSkeleton from "./CarouselSkeleton";
import TextRow from "./TextRow";
import TableSkeleton from "./TableSkeleton";
import BoxedTextRows from "./BoxedTextRows";
import ListSkeleton from "./ListSkeleton";
import ProfileHeaderSkeleton from "./ProfileHeaderSkeleton";
import CategorySkeleton from "./CategorySkeleton";
import PriceBookSkeleton from "./PriceBookSkeleton";
import PrivilegesSkeleton from "./PrivilegesSkeleton";
import RepresentativeSkeleton from "./RepresentativeSkeleton";

const Skeleton = {
  CarouselSkeleton,
  CardSkeleton,
  TextRow,
  TableSkeleton,
  BoxedTextRows,
  ListSkeleton,
  ProfileHeaderSkeleton,
  CategorySkeleton,
  PriceBookSkeleton,
  PrivilegesSkeleton,
  RepresentativeSkeleton
};

export default Skeleton;
